import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { ButtonType, Button } from '../atoms';
import { Overlay } from '../organisms/overlay';
export const DailyLessonChangeCompleteView = ({ onClickBackToHome, onClickShowProfile }) => {
    const isSM = useSmMediaQuery();
    return (React.createElement(Overlay, { background: Colors.White, top: isSM ? Sizes.MobileHeaderHeight : 0 },
        React.createElement("div", { className: css(styles.container) },
            React.createElement("div", { className: css(styles.main) },
                React.createElement("img", { className: css(styles.image), src: "/assets/images/dialog/sabo_thanks.png", alt: "" }),
                React.createElement("div", { className: css(styles.title) }, "\u56DE\u7B54\u3042\u308A\u304C\u3068\u3046\uFF01"),
                React.createElement("div", { className: css(styles.description) }, "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u6700\u65B0\u306B\u3057\u3066\u304A\u304F\u3068\u3001\u3082\u3063\u3068\u5408\u3063\u305F\u30EC\u30C3\u30B9\u30F3\u3092\u304A\u3059\u3059\u3081\u3067\u304D\u308B\u3088\uD83E\uDE84")),
            React.createElement("div", { className: css(styles.footer) },
                React.createElement(Button, { buttonType: ButtonType.primary, className: css(styles.primaryButton), onClick: onClickBackToHome, isRadius: true },
                    React.createElement("div", { className: css(styles.primaryButtonText) }, "OK")),
                React.createElement("div", { className: css(styles.secondaryLink), onClick: onClickShowProfile }, "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u78BA\u8A8D")))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        padding: '20px 20px 10px',
        [MediaBreakPointUp.MD]: {
            maxWidth: 375,
            margin: '0 auto',
        },
    },
    main: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
    },
    image: {
        width: 142,
        height: 133,
        objectFit: 'contain',
    },
    title: {
        marginTop: 20,
        color: Colors.Black,
        fontSize: 22,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '0.88px',
        textAlign: 'center',
        textShadow: '0 0 30px rgba(0, 145, 160, 0.08)',
    },
    description: {
        marginTop: 20,
        color: Colors.Black,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: '0.2px',
        textAlign: 'center',
    },
    primaryButton: {
        display: 'block',
        width: '100%',
        minHeight: 48,
    },
    primaryButtonText: {
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: '1.28px',
        color: Colors.White,
    },
    secondaryLink: {
        marginTop: 8,
        padding: '12px 0',
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: '1.28px',
        color: Colors.PrimaryDark,
    },
});
